// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var FollowerRequestStatus;
(function (FollowerRequestStatus) {
    FollowerRequestStatus[FollowerRequestStatus["UNKNOWN"] = -1] = "UNKNOWN";
    FollowerRequestStatus[FollowerRequestStatus["FOLLOW"] = 0] = "FOLLOW";
    FollowerRequestStatus[FollowerRequestStatus["DISABLE_FOLLOWERS"] = 1] = "DISABLE_FOLLOWERS";
    FollowerRequestStatus[FollowerRequestStatus["REJECT"] = 2] = "REJECT";
    FollowerRequestStatus[FollowerRequestStatus["ALREADY_FOLLOWING_ANOTHER_MASTER"] = 3] = "ALREADY_FOLLOWING_ANOTHER_MASTER";
    FollowerRequestStatus[FollowerRequestStatus["MASTER_ACCOUNT_CANNOT_BE_FOLLOWER"] = 4] = "MASTER_ACCOUNT_CANNOT_BE_FOLLOWER";
})(FollowerRequestStatus || (FollowerRequestStatus = {}));
